import BaseTree from '../packages/base-tree';

const components = {
    BaseTree
};
const install = (Vue, opts = {}) => Object.values(components).forEach(component => Vue.component(component.name, component));
if (window && window.Vue) install(window.Vue);
module.exports = {
    install,
    ...components
};




// WEBPACK FOOTER //
// ./src/index.js